import { createSlice } from "@reduxjs/toolkit";

export const leadsCloserSlice = createSlice({
  name: "leadsCloserReducer",
  initialState: {
    currentPage: 1,
    collapsedColumns: {},
  },
  reducers: {
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setReduxFilters: (state, action) => {
      state.collapsedColumns = action.payload;
    },
  },
});

export const { setCurrentPage, setReduxFilters } = leadsCloserSlice.actions;
export default leadsCloserSlice.reducer;
